import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AgentWhitelist";

const CasinoHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [history, setHistory] = useState([]);
  const [fullHistory, setFullHistory] = useState([]);

  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = history.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(history.length / itemsPerPage);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  /* ================= FETCH HISTORY ================= */
  const fetchHistory = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const res = await axios.get(
        `${base_url}/api/webapi/casinoHistory`,
        {
          headers: {
            Authorization: auth,
            "content-type": "application/json",
          },
        }
      );

      if (res.data?.success) {
        setHistory(res.data.result);
        setFullHistory(res.data.result);
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= FILTER ================= */
  const applyFilter = () => {
    let data = [...fullHistory];

    if (search) {
      data = data.filter(row =>
        row.player_uid.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (startDate && endDate) {
      const start = new Date(startDate + "T00:00:00");
      const end = new Date(endDate + "T23:59:59");

      data = data.filter(row => {
        const rowDate = new Date(row.callback_time);
        return rowDate >= start && rowDate <= end;
      });
    }

    setHistory(data);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  useEffect(() => {
    applyFilter();
  }, [search, startDate, endDate]);

  useEffect(() => {
    const resize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div className={`content-wrapper p-1`}>
        <div className="container-fluid py-4">

          <h3 className="mb-4">🎰 Casino History</h3>

          {/* Filters */}
          <div className="row g-3 mb-3">
            <div className="col-md-4">
              <input
                className="form-control"
                placeholder="Search Player ID"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => {
                  setHistory(fullHistory);
                  setSearch("");
                  setStartDate("");
                  setEndDate("");
                }}
              >
                Reset
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive bg-white rounded shadow-sm p-3">
            <table className="table table-hover align-middle">
              <thead style={{ background: "#182848", color: "#fff" }}>
                <tr className="text-center">
                <th>Client Id</th>
                  <th>Player</th>
                  <th>Game</th>
                  <th>Round</th>
                  <th>Bet</th>
                  <th>Win</th>
                  <th>GGR</th>
                  <th>Status</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      No History Found
                    </td>
                  </tr>
                ) : (
                  currentItems.map(row => (
                    <tr key={row.id} className="text-center">
                           <td>{row.clientId}</td>
                      <td>{row.phone}</td>
                      <td>{row.game_name}</td>
                      <td>{row.serial_number}</td>
                      <td>{Number(row.bet_amount).toFixed(2)}</td>
                      <td className="text-success">
                        {Number(row.win_amount).toFixed(2)}
                      </td>
                      <td className="text-danger">
                        {Number(row.ggr).toFixed(2)}
                      </td>
                      <td>
                        {row.round_status === "WIN" && (
                          <span className="badge bg-success">WIN</span>
                        )}
                        {row.round_status === "LOSS" && (
                          <span className="badge bg-danger">LOSS</span>
                        )}
                        {row.round_status === "PENDING" && (
                          <span className="badge bg-warning">PENDING</span>
                        )}
                      </td>
                      <td>
                        {new Date(row.callback_time).toLocaleString()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-center mt-3 gap-2">
              <button
                className="btn btn-sm btn-dark"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}
              >
                Prev
              </button>
              <button
                className="btn btn-sm btn-dark"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}
              >
                Next
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CasinoHistory;
